<template>
  <div class="home-page">
    <HeroSection />
    <CalculatorPickerSection />
    <BuildForSection />
    <HowToSection />
    <AboutSection />
  </div>
</template>

<script>
import HeroSection from './HeroSection';
import CalculatorPickerSection from './CalculatorPickerSection';
import BuildForSection from './BuildForSection.vue';
import HowToSection from './HowToSection.vue';
import AboutSection from './AboutSection.vue';

export default {
  components: {
    HeroSection,
    CalculatorPickerSection,
    BuildForSection,
    HowToSection,
    AboutSection,
  },
};
</script>

<style scoped lang="scss">
.home-page {
  background-image: url('../../assets/images/home-v3-bg.webp');
  background-color: var(--main-light-shade-1);
}
</style>
